export const DEFAULT_BRAND_COLORS = [
  { id: 'brand-yellow', label: 'Brand yellow', color: '#FDBF47' },
  { id: 'brand-dark', label: 'Brand dark', color: '#111111' },
  { id: 'brand-light', label: 'Brand light', color: '#FFFFFF' },
];
